export default "__VITE_ASSET__6bced70f__"